module.exports = __webpack_public_path__ + "static/media/download.3489d4c5.svg";